import React from 'react';

import { SvgIcon, type SvgIconProps } from '@mui/material';

const Discover = ({ sx, ...props }: SvgIconProps) => {
	return (
		<SvgIcon
			xmlns='http://www.w3.org/2000/svg'
			width='2500'
			height='2500'
			viewBox='0 0 192.756 192.756'
			sx={sx}
			{...props}
		>
			<g fill-rule='evenodd' clip-rule='evenodd'>
				<path fill='#fff' d='M0 0h192.756v192.756H0V0z' />
				<path d='M16.437 74.7H8.504v27.611h7.83c4.225 0 7.212-.928 9.891-3.194 3.091-2.575 5.048-6.491 5.048-10.612 0-8.138-6.079-13.805-14.836-13.805zm6.285 20.811c-1.751 1.443-3.916 2.164-7.418 2.164h-1.442V79.439h1.442c3.502 0 5.563.618 7.418 2.163 1.854 1.648 2.988 4.225 2.988 6.903-.001 2.679-1.134 5.358-2.988 7.006zM33.746 102.312h5.357V74.7h-5.357v27.612zM52.29 85.312c-3.297-1.236-4.224-1.957-4.224-3.503 0-1.751 1.751-2.987 4.018-2.987 1.648 0 2.988.618 4.327 2.163l2.885-3.605c-2.37-2.061-5.151-3.091-8.139-3.091-4.945 0-8.654 3.4-8.654 7.933 0 3.812 1.751 5.667 6.8 7.521 2.164.721 3.194 1.236 3.709 1.545 1.133.722 1.648 1.751 1.648 2.885 0 2.267-1.751 3.915-4.224 3.915s-4.636-1.339-5.873-3.709l-3.399 3.4c2.473 3.605 5.46 5.254 9.581 5.254 5.563 0 9.479-3.709 9.479-9.066-.001-4.431-1.855-6.389-7.934-8.655zM61.872 88.505c0 8.139 6.388 14.424 14.629 14.424 2.267 0 4.327-.413 6.697-1.546v-6.388c-2.164 2.163-4.018 3.091-6.491 3.091-5.357 0-9.272-4.018-9.272-9.582 0-5.254 4.018-9.478 9.066-9.478 2.576 0 4.533.927 6.697 3.091v-6.285c-2.267-1.237-4.224-1.751-6.594-1.751-8.139.001-14.732 6.492-14.732 14.424z' />
				<path
					d='M99.992 74.082c-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424.001-8.035-6.388-14.423-14.732-14.423z'
					fill='#db8135'
				/>
				<path
					d='M99.992 74.082c-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424.001-8.035-6.388-14.423-14.732-14.423zm0 14.423h14.732-14.732z'
					fill='#db8135'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#db8135'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#db8137'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dc8337'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dc8539'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dc853a'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dc853c'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dd873e'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dd873e'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dd883f'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#dd8841'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#de8a41'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#de8a43'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#de8a44'
				/>
				<path
					d='M99.992 88.505h14.732c0-8.036-6.389-14.423-14.732-14.423-8.14 0-14.734 6.388-14.734 14.217 0 8.449 6.285 14.63 14.734 14.63 8.24 0 14.732-6.285 14.732-14.424H99.992z'
					fill='#de8c46'
				/>
				<path
					d='M99.992 88.505h14.732-14.732zm14.733 0c0-.125-.002-.25-.006-.375v-.005a11.204 11.204 0 0 0-.014-.368v-.01a13.897 13.897 0 0 0-.023-.36c0-.005 0-.01-.002-.015a13.614 13.614 0 0 0-.029-.353c-.002-.007-.002-.013-.002-.02a10.44 10.44 0 0 0-.041-.345v-.003a18.44 18.44 0 0 0-.045-.328c-.002-.011-.004-.022-.004-.033-.018-.108-.035-.215-.055-.323l-.006-.036-.031-.175-.041-.207-.021-.099c-.018-.084-.035-.168-.055-.251-.008-.039-.02-.077-.027-.116l-.059-.234-.059-.22-.029-.108c-.021-.077-.045-.153-.066-.229l-.035-.119c-1.824-5.883-7.309-10.092-14.082-10.092-5.962 0-11.093 3.428-13.413 8.338a14.568 14.568 0 0 0-1.32 5.984c.011 1.785.304 3.468.837 5.011l.046.129.02.054a14.705 14.705 0 0 0 2.435 4.248c2.65 3.162 6.686 5.083 11.395 5.083 6.695 0 12.234-4.148 14.078-10.07l.094-.318v-.001a14.66 14.66 0 0 0 .516-2.899l.002-.002c.008-.124.018-.249.023-.374v-.001a15.994 15.994 0 0 0 .019-.758z'
					fill='#df8e47'
				/>
				<path
					d='M99.992 88.505h14.629c0-5.604-3.209-10.455-7.875-12.879-2.008-.988-4.295-1.544-6.754-1.544-3.165 0-6.092.967-8.493 2.605-3.707 2.633-6.138 6.94-6.138 11.818 0 5.366 2.942 10.089 7.288 12.635 2.133 1.149 4.624 1.789 7.343 1.789 3.428 0 6.551-1.088 9.031-2.942 3.4-2.688 5.598-6.845 5.598-11.482H99.992z'
					fill='#df8e48'
				/>
				<path
					d='M99.992 88.505h14.422c0-7.933-6.49-14.423-14.422-14.423-.125 0-.248.002-.371.005h-.01c-7.758.203-14.044 6.613-14.044 14.418a14.536 14.536 0 0 0 9.753 13.744c1.454.443 3.021.681 4.671.681 2.014 0 3.922-.377 5.658-1.062a14.541 14.541 0 0 0 8.764-13.362H99.992v-.001z'
					fill='#df8e4a'
				/>
				<path
					d='M99.992 88.505h14.32c0-7.83-6.389-14.321-14.32-14.321-7.934 0-14.322 6.491-14.322 14.321a14.29 14.29 0 0 0 14.322 14.321 14.29 14.29 0 0 0 14.32-14.321h-14.32z'
					fill='#df904a'
				/>
				<path
					d='M99.992 88.505h14.217c0-7.83-6.389-14.115-14.217-14.115-7.831 0-14.219 6.285-14.219 14.115 0 7.831 6.388 14.218 14.219 14.218 7.828 0 14.217-6.388 14.217-14.218H99.992z'
					fill='#e0914c'
				/>
				<path
					d='M99.992 88.505h14.113c0-7.727-6.387-14.011-14.113-14.011-7.728 0-14.116 6.284-14.116 14.011 0 7.831 6.388 14.115 14.116 14.115 7.727 0 14.113-6.284 14.113-14.115H99.992z'
					fill='#e0914e'
				/>
				<path
					d='M99.992 88.505H113.9c0-7.624-6.182-13.909-13.908-13.909-7.728 0-13.91 6.285-13.91 13.909 0 7.727 6.182 14.011 13.91 14.011 7.727 0 13.908-6.284 13.908-14.011H99.992z'
					fill='#df924f'
				/>
				<path
					d='M99.992 88.505h13.805c0-7.624-6.182-13.805-13.805-13.805-7.625 0-13.807 6.182-13.807 13.805s6.182 13.806 13.807 13.806c7.623 0 13.805-6.183 13.805-13.806H99.992z'
					fill='#e09351'
				/>
				<path
					d='M99.992 88.505h13.701c0-7.521-6.182-13.599-13.701-13.599-7.522 0-13.704 6.078-13.704 13.599 0 7.624 6.182 13.703 13.704 13.703 7.52 0 13.701-6.079 13.701-13.703H99.992z'
					fill='#e09552'
				/>
				<path
					d='M99.992 88.505h13.496c0-7.417-5.977-13.496-13.496-13.496-7.522 0-13.601 6.079-13.601 13.496 0 7.521 6.079 13.599 13.601 13.599 7.52 0 13.496-6.078 13.496-13.599H99.992z'
					fill='#e09554'
				/>
				<path
					d='M99.992 88.505h13.393a13.368 13.368 0 0 0-13.393-13.393 13.367 13.367 0 0 0-13.394 13.393c0 7.418 5.975 13.497 13.394 13.497 7.416 0 13.393-6.079 13.393-13.497H99.992z'
					fill='#e09555'
				/>
				<path
					d='M99.992 88.505h13.289c0-7.315-5.975-13.29-13.289-13.29-7.316 0-13.292 5.975-13.292 13.29 0 7.418 5.976 13.291 13.292 13.291a13.257 13.257 0 0 0 13.289-13.291H99.992z'
					fill='#e19756'
				/>
				<path
					d='M99.992 88.505h13.186c0-7.211-5.871-13.084-13.186-13.084-7.316 0-13.188 5.873-13.188 13.084a13.146 13.146 0 0 0 13.188 13.187 13.146 13.146 0 0 0 13.186-13.187H99.992z'
					fill='#e19757'
				/>
				<path
					d='M99.992 88.505h12.98c0-7.211-5.77-12.981-12.98-12.981-7.213 0-13.085 5.77-13.085 12.981 0 7.212 5.873 13.084 13.085 13.084 7.211 0 12.98-5.873 12.98-13.084h-12.98z'
					fill='#e29959'
				/>
				<path
					d='M99.992 88.505h12.877c0-7.109-5.77-12.878-12.877-12.878-7.11 0-12.879 5.769-12.879 12.878s5.77 12.981 12.879 12.981c7.107 0 12.877-5.872 12.877-12.981H99.992z'
					fill='#e2995b'
				/>
				<path
					d='M99.992 88.505h12.773c0-7.005-5.77-12.775-12.773-12.775-7.007 0-12.776 5.77-12.776 12.775 0 7.109 5.77 12.775 12.776 12.775 7.004 0 12.773-5.666 12.773-12.775H99.992z'
					fill='#e29b5b'
				/>
				<path
					d='M99.992 88.505h12.672c0-6.903-5.668-12.569-12.672-12.569-7.007 0-12.673 5.666-12.673 12.569 0 7.006 5.667 12.672 12.673 12.672 7.004 0 12.672-5.667 12.672-12.672H99.992z'
					fill='#e29b5d'
				/>
				<path
					d='M99.992 88.505h12.465a12.442 12.442 0 0 0-12.465-12.466c-6.904 0-12.467 5.563-12.467 12.466s5.563 12.57 12.467 12.57c6.902 0 12.465-5.667 12.465-12.57H99.992z'
					fill='#e39d5f'
				/>
				<path
					d='M99.992 88.505h12.361c0-6.8-5.562-12.363-12.361-12.363-6.801 0-12.364 5.563-12.364 12.363 0 6.903 5.563 12.466 12.364 12.466 6.799 0 12.361-5.563 12.361-12.466H99.992z'
					fill='#e39d61'
				/>
				<path
					d='M99.992 88.505h12.26c0-6.697-5.461-12.26-12.26-12.26-6.801 0-12.261 5.563-12.261 12.26 0 6.8 5.46 12.26 12.261 12.26 6.799 0 12.26-5.46 12.26-12.26h-12.26z'
					fill='#e39f63'
				/>
				<path
					d='M99.992 88.505h12.156c0-6.697-5.461-12.054-12.156-12.054-6.698 0-12.158 5.357-12.158 12.054s5.46 12.158 12.158 12.158c6.695 0 12.156-5.461 12.156-12.158H99.992z'
					fill='#e39f63'
				/>
				<path
					d='M99.992 88.505h11.949c0-6.593-5.355-11.951-11.949-11.951-6.595 0-11.952 5.357-11.952 11.951 0 6.697 5.357 12.054 11.952 12.054 6.594 0 11.949-5.357 11.949-12.054H99.992z'
					fill='#e39f64'
				/>
				<path
					d='M99.992 88.505h11.848c0-6.49-5.254-11.848-11.848-11.848-6.595 0-11.849 5.358-11.849 11.848 0 6.594 5.254 11.952 11.849 11.952 6.594 0 11.848-5.358 11.848-11.952H99.992z'
					fill='#e4a166'
				/>
				<path
					d='M99.992 88.505h11.744c0-6.49-5.254-11.745-11.744-11.745-6.492 0-11.746 5.254-11.746 11.745s5.254 11.746 11.746 11.746c6.49 0 11.744-5.255 11.744-11.746H99.992z'
					fill='#e4a367'
				/>
				<path
					d='M99.992 88.505h11.641c0-6.387-5.254-11.539-11.641-11.539-6.389 0-11.643 5.151-11.643 11.539 0 6.491 5.254 11.642 11.643 11.642 6.387 0 11.641-5.151 11.641-11.642H99.992z'
					fill='#e4a369'
				/>
				<path
					d='M99.992 88.505h11.436c0-6.284-5.049-11.436-11.436-11.436-6.389 0-11.437 5.152-11.437 11.436 0 6.388 5.048 11.539 11.437 11.539 6.387 0 11.436-5.151 11.436-11.539H99.992z'
					fill='#e4a36a'
				/>
				<path
					d='M99.992 88.505h11.332a11.301 11.301 0 0 0-11.332-11.333 11.3 11.3 0 0 0-11.334 11.333c0 6.285 5.048 11.436 11.334 11.436 6.283 0 11.332-5.151 11.332-11.436H99.992z'
					fill='#e5a56c'
				/>
				<path
					d='M99.992 88.505h11.229c0-6.181-5.049-11.229-11.229-11.229-6.183 0-11.231 5.048-11.231 11.229 0 6.182 5.048 11.23 11.231 11.23 6.18 0 11.229-5.048 11.229-11.23H99.992z'
					fill='#e5a56c'
				/>
				<path
					d='M99.992 88.505h11.125c0-6.078-5.047-11.023-11.125-11.023-6.08 0-11.128 4.945-11.128 11.023 0 6.182 5.048 11.126 11.128 11.126 6.078 0 11.125-4.944 11.125-11.126H99.992z'
					fill='#e5a76e'
				/>
				<path
					d='M99.992 88.505h10.92c0-5.975-4.842-10.92-10.92-10.92-6.08 0-10.921 4.945-10.921 10.92 0 6.079 4.842 11.024 10.921 11.024 6.078 0 10.92-4.945 10.92-11.024h-10.92z'
					fill='#e5a770'
				/>
				<path
					d='M99.992 88.505h10.816c0-5.975-4.842-10.817-10.816-10.817-5.977 0-10.819 4.842-10.819 10.817 0 5.976 4.842 10.818 10.819 10.818 5.975 0 10.816-4.842 10.816-10.818H99.992z'
					fill='#e6a970'
				/>
				<path
					d='M99.992 88.505h10.713c0-5.872-4.842-10.714-10.713-10.714-5.874 0-10.716 4.842-10.716 10.714 0 5.976 4.842 10.714 10.716 10.714 5.871 0 10.713-4.738 10.713-10.714H99.992z'
					fill='#e6a972'
				/>
				<path
					d='M99.992 88.505h10.611c0-5.769-4.74-10.508-10.611-10.508-5.874 0-10.613 4.739-10.613 10.508a10.597 10.597 0 0 0 10.613 10.612 10.597 10.597 0 0 0 10.611-10.612H99.992z'
					fill='#e6ab74'
				/>
				<path
					d='M99.992 88.505h10.404A10.377 10.377 0 0 0 99.992 78.1a10.377 10.377 0 0 0-10.407 10.405c0 5.77 4.636 10.509 10.407 10.509 5.768 0 10.404-4.739 10.404-10.509H99.992z'
					fill='#e6ab75'
				/>
				<path
					d='M99.992 88.505h10.301c0-5.667-4.635-10.302-10.301-10.302-5.667 0-10.304 4.636-10.304 10.302 0 5.77 4.636 10.303 10.304 10.303a10.266 10.266 0 0 0 10.301-10.303H99.992z'
					fill='#e7ad77'
				/>
				<path
					d='M99.992 88.505h10.199c0-5.563-4.533-10.199-10.199-10.199-5.667 0-10.201 4.636-10.201 10.199 0 5.667 4.533 10.2 10.201 10.2a10.157 10.157 0 0 0 10.199-10.2H99.992z'
					fill='#e7ad77'
				/>
				<path
					d='M99.992 88.505h10.096c0-5.563-4.533-9.994-10.096-9.994-5.564 0-10.098 4.431-10.098 9.994 0 5.564 4.533 10.097 10.098 10.097 5.562 0 10.096-4.533 10.096-10.097H99.992z'
					fill='#e8af79'
				/>
				<path
					d='M99.992 88.505h9.889c0-5.46-4.43-9.89-9.889-9.89-5.461 0-9.892 4.43-9.892 9.89 0 5.564 4.43 9.994 9.892 9.994 5.459 0 9.889-4.43 9.889-9.994h-9.889z'
					fill='#e8af7b'
				/>
				<path
					d='M99.992 88.505h9.787c0-5.357-4.328-9.788-9.787-9.788-5.461 0-9.789 4.431-9.789 9.788 0 5.46 4.327 9.788 9.789 9.788 5.459 0 9.787-4.327 9.787-9.788h-9.787z'
					fill='#e8b17b'
				/>
				<path
					d='M99.992 88.505h9.684a9.674 9.674 0 0 0-9.684-9.684 9.674 9.674 0 0 0-9.686 9.684 9.674 9.674 0 0 0 9.686 9.685 9.675 9.675 0 0 0 9.684-9.685h-9.684z'
					fill='#e8b17d'
				/>
				<path
					d='M99.992 88.505h9.58c0-5.254-4.326-9.478-9.58-9.478-5.255 0-9.583 4.224-9.583 9.478s4.327 9.582 9.583 9.582c5.254 0 9.58-4.327 9.58-9.582h-9.58z'
					fill='#e8b17e'
				/>
				<path
					d='M99.992 88.505h9.375c0-5.151-4.225-9.375-9.375-9.375a9.344 9.344 0 0 0-9.376 9.375c0 5.254 4.121 9.478 9.376 9.478 5.15 0 9.375-4.224 9.375-9.478h-9.375z'
					fill='#e9b381'
				/>
				<path
					d='M99.992 88.505h9.271a9.233 9.233 0 0 0-9.271-9.272 9.234 9.234 0 0 0-9.273 9.272 9.235 9.235 0 0 0 9.273 9.273 9.234 9.234 0 0 0 9.271-9.273h-9.271z'
					fill='#e9b381'
				/>
				<path
					d='M99.992 88.505h9.168c0-5.048-4.121-9.169-9.168-9.169-5.049 0-9.17 4.121-9.17 9.169s4.121 9.169 9.17 9.169c5.047 0 9.168-4.121 9.168-9.169h-9.168z'
					fill='#e9b583'
				/>
				<path
					d='M99.992 88.505h9.066c0-4.945-4.123-8.963-9.066-8.963-4.946 0-9.067 4.018-9.067 8.963 0 5.048 4.121 9.066 9.067 9.066 4.943 0 9.066-4.018 9.066-9.066h-9.066z'
					fill='#e9b584'
				/>
				<path
					d='M99.992 88.505h8.859c0-4.842-3.916-8.86-8.859-8.86-4.946 0-8.861 4.018-8.861 8.86 0 4.945 3.915 8.963 8.861 8.963 4.943 0 8.859-4.018 8.859-8.963h-8.859z'
					fill='#eab786'
				/>
				<path
					d='M99.992 88.505h8.756a8.749 8.749 0 0 0-8.756-8.757c-4.843 0-8.758 3.915-8.758 8.757s3.915 8.757 8.758 8.757a8.749 8.749 0 0 0 8.756-8.757h-8.756z'
					fill='#eab788'
				/>
				<path
					d='M99.992 88.505h8.652c0-4.739-3.914-8.654-8.652-8.654-4.74 0-8.655 3.915-8.655 8.654 0 4.842 3.915 8.654 8.655 8.654 4.738 0 8.652-3.812 8.652-8.654h-8.652z'
					fill='#ebb989'
				/>
				<path
					d='M99.992 88.505h8.551c0-4.636-3.812-8.448-8.551-8.448-4.74 0-8.552 3.812-8.552 8.448a8.53 8.53 0 0 0 8.552 8.551 8.53 8.53 0 0 0 8.551-8.551h-8.551z'
					fill='#ebb98a'
				/>
				<path
					d='M99.992 88.505h8.344a8.31 8.31 0 0 0-8.344-8.345c-4.637 0-8.346 3.708-8.346 8.345s3.709 8.449 8.346 8.449c4.635 0 8.344-3.812 8.344-8.449h-8.344z'
					fill='#ebbb8c'
				/>
				<path
					d='M99.992 88.505h8.24c0-4.533-3.707-8.242-8.24-8.242-4.534 0-8.243 3.708-8.243 8.242 0 4.636 3.709 8.243 8.243 8.243 4.533 0 8.24-3.606 8.24-8.243h-8.24z'
					fill='#ebbb8c'
				/>
				<path
					d='M99.992 88.505h8.139c0-4.43-3.605-8.139-8.139-8.139-4.534 0-8.14 3.708-8.14 8.139a8.091 8.091 0 0 0 8.14 8.139 8.09 8.09 0 0 0 8.139-8.139h-8.139z'
					fill='#ecbd8f'
				/>
				<path
					d='M99.992 88.505h8.035c0-4.43-3.605-7.933-8.035-7.933-4.431 0-8.037 3.502-8.037 7.933s3.606 8.037 8.037 8.037c4.43 0 8.035-3.606 8.035-8.037h-8.035z'
					fill='#ecbd90'
				/>
				<path
					d='M99.992 88.505h7.828a7.826 7.826 0 0 0-7.828-7.83 7.827 7.827 0 0 0-7.831 7.83c0 4.327 3.503 7.933 7.831 7.933 4.326 0 7.828-3.606 7.828-7.933h-7.828z'
					fill='#ecbf93'
				/>
				<path
					d='M99.992 88.505h7.727c0-4.224-3.504-7.727-7.727-7.727-4.328 0-7.728 3.503-7.728 7.727 0 4.327 3.4 7.727 7.728 7.727 4.223 0 7.727-3.4 7.727-7.727h-7.727z'
					fill='#ecbf93'
				/>
				<path
					d='M99.992 88.505h7.623c0-4.224-3.4-7.624-7.623-7.624-4.225 0-7.625 3.399-7.625 7.624s3.4 7.624 7.625 7.624a7.606 7.606 0 0 0 7.623-7.624h-7.623z'
					fill='#edc195'
				/>
				<path
					d='M99.992 88.505h7.52c0-4.121-3.398-7.417-7.52-7.417s-7.522 3.297-7.522 7.417c0 4.121 3.4 7.521 7.522 7.521 4.121 0 7.52-3.4 7.52-7.521h-7.52z'
					fill='#edc196'
				/>
				<path
					d='M99.992 88.505h7.314c0-4.018-3.297-7.315-7.314-7.315-4.019 0-7.316 3.297-7.316 7.315 0 4.121 3.297 7.418 7.316 7.418 4.018 0 7.314-3.297 7.314-7.418h-7.314z'
					fill='#eec397'
				/>
				<path
					d='M99.992 88.505h7.211c0-3.915-3.193-7.211-7.211-7.211-4.019 0-7.213 3.297-7.213 7.211a7.168 7.168 0 0 0 7.213 7.212 7.167 7.167 0 0 0 7.211-7.212h-7.211z'
					fill='#eec399'
				/>
				<path
					d='M99.992 88.505h7.107c0-3.915-3.193-7.109-7.107-7.109-3.916 0-7.11 3.194-7.11 7.109 0 3.916 3.194 7.109 7.11 7.109 3.914 0 7.107-3.193 7.107-7.109h-7.107z'
					fill='#eec59b'
				/>
				<path
					d='M99.992 88.505h7.004c0-3.812-3.193-6.903-7.004-6.903-3.813 0-7.007 3.091-7.007 6.903 0 3.916 3.194 7.006 7.007 7.006 3.811 0 7.004-3.09 7.004-7.006h-7.004z'
					fill='#eec69d'
				/>
				<path
					d='M99.992 88.505h6.799c0-3.708-2.988-6.8-6.799-6.8-3.813 0-6.801 3.091-6.801 6.8 0 3.812 2.988 6.903 6.801 6.903 3.811 0 6.799-3.091 6.799-6.903h-6.799z'
					fill='#eec69f'
				/>
				<path
					d='M99.992 88.505h6.695a6.684 6.684 0 0 0-6.695-6.697 6.684 6.684 0 0 0-6.698 6.697 6.684 6.684 0 0 0 6.698 6.697 6.683 6.683 0 0 0 6.695-6.697h-6.695z'
					fill='#efc89f'
				/>
				<path
					d='M99.992 88.505h6.594c0-3.605-2.988-6.593-6.594-6.593-3.607 0-6.595 2.988-6.595 6.593a6.574 6.574 0 0 0 6.595 6.594 6.574 6.574 0 0 0 6.594-6.594h-6.594z'
					fill='#efc8a1'
				/>
				<path
					d='M99.992 88.505h6.49c0-3.502-2.885-6.387-6.49-6.387-3.607 0-6.492 2.885-6.492 6.387a6.464 6.464 0 0 0 6.492 6.491 6.464 6.464 0 0 0 6.49-6.491h-6.49z'
					fill='#efcaa3'
				/>
				<path
					d='M99.992 88.505h6.283a6.243 6.243 0 0 0-6.283-6.284 6.245 6.245 0 0 0-6.286 6.284c0 3.503 2.782 6.388 6.286 6.388 3.502 0 6.283-2.884 6.283-6.388h-6.283z'
					fill='#efcaa3'
				/>
				<path
					d='M99.992 88.505h6.18c0-3.4-2.781-6.181-6.18-6.181-3.401 0-6.183 2.781-6.183 6.181s2.782 6.182 6.183 6.182c3.398 0 6.18-2.782 6.18-6.182h-6.18z'
					fill='#f0cca6'
				/>
				<path
					d='M99.992 88.505h6.078c0-3.296-2.783-6.078-6.078-6.078-3.401 0-6.08 2.782-6.08 6.078 0 3.4 2.679 6.079 6.08 6.079 3.295 0 6.078-2.679 6.078-6.079h-6.078z'
					fill='#f0cca8'
				/>
				<path
					d='M99.992 88.505h5.975c0-3.296-2.68-5.872-5.975-5.872-3.297 0-5.977 2.576-5.977 5.872a5.98 5.98 0 0 0 5.977 5.976 5.98 5.98 0 0 0 5.975-5.976h-5.975z'
					fill='#f1ceaa'
				/>
				<path
					d='M99.992 88.505h5.768a5.758 5.758 0 0 0-5.768-5.769c-3.195 0-5.771 2.575-5.771 5.769s2.576 5.873 5.771 5.873c3.193 0 5.768-2.679 5.768-5.873h-5.768z'
					fill='#f1ceaa'
				/>
				<path
					d='M99.992 88.505h5.666c0-3.09-2.576-5.667-5.666-5.667-3.092 0-5.667 2.576-5.667 5.667a5.65 5.65 0 0 0 5.667 5.667 5.65 5.65 0 0 0 5.666-5.667h-5.666z'
					fill='#f1d0ad'
				/>
				<path
					d='M99.992 88.505h5.562c0-2.988-2.473-5.563-5.562-5.563-3.092 0-5.564 2.575-5.564 5.563a5.54 5.54 0 0 0 5.564 5.564 5.54 5.54 0 0 0 5.562-5.564h-5.562z'
					fill='#f1d0ae'
				/>
				<path
					d='M99.992 88.505h5.459c0-2.988-2.473-5.357-5.459-5.357-2.988 0-5.461 2.369-5.461 5.357s2.473 5.46 5.461 5.46c2.986 0 5.459-2.473 5.459-5.46h-5.459z'
					fill='#f2d2b1'
				/>
				<path
					d='M99.992 88.505h5.254c0-2.884-2.371-5.254-5.254-5.254-2.885 0-5.255 2.37-5.255 5.254 0 2.988 2.371 5.357 5.255 5.357 2.883 0 5.254-2.37 5.254-5.357h-5.254z'
					fill='#f2d2b3'
				/>
				<path
					d='M99.992 88.505h5.15c0-2.782-2.268-5.151-5.15-5.151-2.885 0-5.152 2.369-5.152 5.151 0 2.885 2.268 5.151 5.152 5.151 2.883 0 5.15-2.267 5.15-5.151h-5.15z'
					fill='#f3d4b4'
				/>
				<path
					d='M99.992 88.505h5.047a5.055 5.055 0 0 0-5.047-5.048c-2.783 0-5.049 2.267-5.049 5.048s2.266 5.048 5.049 5.048a5.056 5.056 0 0 0 5.047-5.048h-5.047z'
					fill='#f3d4b5'
				/>
				<path
					d='M99.992 88.505h4.943c0-2.678-2.266-4.842-4.943-4.842-2.68 0-4.946 2.164-4.946 4.842 0 2.782 2.267 4.945 4.946 4.945 2.678 0 4.943-2.164 4.943-4.945h-4.943z'
					fill='#f3d4b7'
				/>
				<path
					d='M99.992 88.505h4.738a4.726 4.726 0 0 0-4.738-4.739 4.726 4.726 0 0 0-4.74 4.739c0 2.679 2.061 4.842 4.74 4.842 2.678 0 4.738-2.164 4.738-4.842h-4.738z'
					fill='#f3d6b8'
				/>
				<path
					d='M99.992 88.505h4.635a4.617 4.617 0 0 0-4.635-4.636c-2.576 0-4.637 2.061-4.637 4.636s2.061 4.636 4.637 4.636a4.617 4.617 0 0 0 4.635-4.636h-4.635z'
					fill='#f4d8ba'
				/>
				<path
					d='M99.992 88.505h4.533c0-2.473-2.061-4.533-4.533-4.533s-4.534 2.061-4.534 4.533c0 2.576 2.062 4.533 4.534 4.533s4.533-1.958 4.533-4.533h-4.533z'
					fill='#f4d9bc'
				/>
				<path
					d='M99.992 88.505h4.43c0-2.37-1.957-4.327-4.43-4.327s-4.431 1.957-4.431 4.327c0 2.473 1.958 4.43 4.431 4.43s4.43-1.958 4.43-4.43h-4.43z'
					fill='#f4d9be'
				/>
				<path
					d='M99.992 88.505h4.223c0-2.37-1.854-4.224-4.223-4.224-2.371 0-4.225 1.854-4.225 4.224s1.854 4.327 4.225 4.327c2.369 0 4.223-1.958 4.223-4.327h-4.223z'
					fill='#f4dbbf'
				/>
				<path
					d='M99.992 88.505h4.121a4.133 4.133 0 0 0-4.121-4.121c-2.268 0-4.122 1.854-4.122 4.121s1.854 4.121 4.122 4.121a4.133 4.133 0 0 0 4.121-4.121h-4.121z'
					fill='#f4dbc0'
				/>
				<path
					d='M99.992 88.505h4.018c0-2.164-1.855-4.018-4.018-4.018-2.164 0-4.019 1.854-4.019 4.018 0 2.267 1.855 4.018 4.019 4.018 2.162 0 4.018-1.751 4.018-4.018h-4.018z'
					fill='#f5ddc3'
				/>
				<path
					d='M99.992 88.505h3.914c0-2.061-1.752-3.812-3.914-3.812-2.164 0-3.916 1.751-3.916 3.812a3.914 3.914 0 1 0 7.83 0h-3.914z'
					fill='#f5ddc3'
				/>
				<path
					d='M99.992 88.505h3.707c0-2.061-1.646-3.708-3.707-3.708s-3.71 1.648-3.71 3.708 1.649 3.812 3.71 3.812 3.707-1.751 3.707-3.812h-3.707z'
					fill='#f6dfc6'
				/>
				<path
					d='M99.992 88.505h3.605c0-1.958-1.648-3.605-3.605-3.605-1.959 0-3.607 1.648-3.607 3.605 0 2.061 1.648 3.606 3.607 3.606 1.957 0 3.605-1.545 3.605-3.606h-3.605z'
					fill='#f6dfc7'
				/>
				<path
					d='M99.992 88.505h3.502c0-1.854-1.545-3.502-3.502-3.502-1.959 0-3.504 1.648-3.504 3.502a3.474 3.474 0 0 0 3.504 3.503 3.474 3.474 0 0 0 3.502-3.503h-3.502z'
					fill='#f6e1ca'
				/>
				<path
					d='M99.992 88.505h3.398c0-1.854-1.545-3.296-3.398-3.296-1.855 0-3.401 1.442-3.401 3.296 0 1.855 1.545 3.4 3.401 3.4 1.854 0 3.398-1.545 3.398-3.4h-3.398z'
					fill='#f6e1cc'
				/>
				<path
					d='M99.992 88.505h3.193a3.21 3.21 0 0 0-3.193-3.194 3.21 3.21 0 0 0-3.195 3.194c0 1.855 1.443 3.297 3.195 3.297 1.75 0 3.193-1.442 3.193-3.297h-3.193z'
					fill='#f7e3cd'
				/>
				<path
					d='M99.992 88.505h3.09c0-1.648-1.34-3.09-3.09-3.09-1.752 0-3.092 1.442-3.092 3.09 0 1.751 1.34 3.091 3.092 3.091 1.75 0 3.09-1.34 3.09-3.091h-3.09z'
					fill='#f7e3cf'
				/>
				<path
					d='M99.992 88.505h2.986a2.99 2.99 0 0 0-2.986-2.988 2.989 2.989 0 0 0 0 5.976 2.989 2.989 0 0 0 2.986-2.988h-2.986z'
					fill='#f7e3d0'
				/>
				<path
					d='M99.992 88.505h2.883c0-1.545-1.338-2.782-2.883-2.782-1.547 0-2.885 1.237-2.885 2.782a2.879 2.879 0 0 0 2.885 2.885 2.878 2.878 0 0 0 2.883-2.885h-2.883z'
					fill='#f8e5d1'
				/>
				<path
					d='M99.992 88.505h2.678c0-1.442-1.133-2.678-2.678-2.678a2.66 2.66 0 0 0-2.68 2.678c0 1.545 1.133 2.782 2.68 2.782 1.545 0 2.678-1.236 2.678-2.782h-2.678z'
					fill='#f8e8d4'
				/>
				<path
					d='M99.992 88.505h2.574a2.55 2.55 0 0 0-2.574-2.576 2.551 2.551 0 0 0-2.576 2.576 2.55 2.55 0 0 0 2.576 2.576 2.55 2.55 0 0 0 2.574-2.576h-2.574z'
					fill='#f8e8d6'
				/>
				<path
					d='M99.992 88.505h2.473c0-1.339-1.135-2.37-2.473-2.37-1.34 0-2.473 1.03-2.473 2.37s1.133 2.473 2.473 2.473c1.338 0 2.473-1.133 2.473-2.473h-2.473z'
					fill='#f8e8d8'
				/>
				<path
					d='M99.992 88.505h2.369c0-1.236-1.135-2.267-2.369-2.267-1.238 0-2.371 1.031-2.371 2.267 0 1.339 1.133 2.37 2.371 2.37 1.234 0 2.369-1.03 2.369-2.37h-2.369z'
					fill='#f9ead9'
				/>
				<path
					d='M99.992 88.505h2.162c0-1.133-.928-2.164-2.162-2.164-1.238 0-2.164 1.03-2.164 2.164 0 1.237.926 2.267 2.164 2.267 1.234 0 2.162-1.03 2.162-2.267h-2.162z'
					fill='#faecdc'
				/>
				<path
					d='M99.992 88.505h2.061a2.068 2.068 0 0 0-2.061-2.061c-1.135 0-2.061.927-2.061 2.061s.926 2.061 2.061 2.061a2.067 2.067 0 0 0 2.061-2.061h-2.061z'
					fill='#faecdd'
				/>
				<path
					d='M99.992 88.505h1.957c0-1.03-.928-1.854-1.957-1.854-1.031 0-1.959.824-1.959 1.854 0 1.133.928 1.958 1.959 1.958a1.957 1.957 0 0 0 1.957-1.958h-1.957z'
					fill='#faecdf'
				/>
				<path
					d='M99.992 88.505h1.854c0-.927-.824-1.751-1.854-1.751-1.031 0-1.855.824-1.855 1.751 0 1.031.824 1.855 1.855 1.855a1.847 1.847 0 0 0 1.854-1.855h-1.854z'
					fill='#faeee0'
				/>
				<path
					d='M99.992 88.505h1.648c0-.927-.723-1.648-1.648-1.648-.928 0-1.65.721-1.65 1.648s.723 1.751 1.65 1.751c.926 0 1.648-.824 1.648-1.751h-1.648z'
					fill='#fbf0e3'
				/>
				<path
					d='M99.992 88.505h1.545c0-.824-.723-1.545-1.545-1.545-.824 0-1.547.721-1.547 1.545 0 .927.723 1.545 1.547 1.545.822 0 1.545-.618 1.545-1.545h-1.545z'
					fill='#fbf1e5'
				/>
				<path
					d='M99.992 88.505h1.441c0-.721-.619-1.339-1.441-1.339-.824 0-1.443.618-1.443 1.339 0 .825.619 1.443 1.443 1.443.822 0 1.441-.618 1.441-1.443h-1.441z'
					fill='#fbf1e7'
				/>
				<path
					d='M99.992 88.505h1.338c0-.721-.617-1.236-1.338-1.236-.723 0-1.34.515-1.34 1.236 0 .722.617 1.339 1.34 1.339.721 0 1.338-.618 1.338-1.339h-1.338z'
					fill='#fcf3e8'
				/>
				<path
					d='M99.992 88.505h1.133c0-.618-.516-1.133-1.133-1.133-.619 0-1.135.516-1.135 1.133 0 .722.516 1.237 1.135 1.237.617 0 1.133-.515 1.133-1.237h-1.133z'
					fill='#fcf3ea'
				/>
				<path
					d='M99.992 88.505h1.029c0-.515-.412-1.03-1.029-1.03-.619 0-1.031.515-1.031 1.03 0 .619.412 1.031 1.031 1.031.617 0 1.029-.412 1.029-1.031h-1.029z'
					fill='#fcf5ed'
				/>
				<path
					d='M99.992 88.505h.926c0-.515-.412-.824-.926-.824-.516 0-.928.309-.928.824s.412.927.928.927a.923.923 0 0 0 .926-.927h-.926z'
					fill='#fcf5ef'
				/>
				<path
					d='M99.992 88.505h.822c0-.412-.412-.721-.822-.721-.412 0-.824.31-.824.721 0 .412.412.825.824.825.41 0 .822-.413.822-.825h-.822z'
					fill='#fdf8f1'
				/>
				<path
					d='M99.992 88.505h.617c0-.309-.309-.618-.617-.618-.311 0-.619.309-.619.618 0 .412.309.722.619.722.309 0 .617-.31.617-.722h-.617z'
					fill='#fdf8f3'
				/>
				<path
					d='M99.992 88.505h.514c0-.206-.205-.515-.514-.515-.311 0-.516.309-.516.515 0 .309.205.515.516.515.309 0 .514-.206.514-.515h-.514z'
					fill='#fdf8f5'
				/>
				<path
					d='M99.992 88.505h.41c0-.206-.205-.309-.41-.309-.207 0-.412.103-.412.309s.205.412.412.412c.205 0 .41-.206.41-.412h-.41z'
					fill='#fefbf6'
				/>
				<path
					d='M99.992 88.505h.205c0-.103-.104-.206-.205-.206-.104 0-.311.103-.311.206 0 .206.207.309.311.309.102 0 .205-.103.205-.309h-.205z'
					fill='#fffffb'
				/>
				<path
					d='M99.992 88.505h.102s0-.103-.102-.103c-.104 0-.104.103-.104.103 0 .103 0 .206.104.206.102 0 .102-.103.102-.206h-.102z'
					fill='#fff'
				/>
				<path d='M126.881 93.245L119.566 74.7h-5.976l11.746 28.332h2.885L140.172 74.7h-5.873l-7.418 18.545zM142.645 102.312h15.248v-4.637h-9.891v-7.418h9.478v-4.739h-9.478v-6.079h9.891V74.7h-15.248v27.612zM179.219 82.839c0-5.151-3.504-8.139-9.787-8.139h-7.934v27.611h5.357V91.287h.721l7.418 11.024h6.594l-8.654-11.643c4.017-.823 6.285-3.605 6.285-7.829zM168.4 87.476h-1.545v-8.448h1.648c3.4 0 5.15 1.442 5.15 4.121.001 2.781-1.749 4.327-5.253 4.327zM9.731 110.419v2.474h3.055v1.001H9.731v4.31H8.633v-8.787h4.253v1.002H9.731zM17.901 109.417H19v8.787h-1.099v-8.787zM24.305 108.995l6.59 6.915v-6.493h1.098v9.149l-6.597-6.911v6.549h-1.091v-9.209zM42.152 115.001h-3.13l1.564-3.558 1.566 3.558zm.45 1.002l1.002 2.201h1.182l-4.199-9.16-4.197 9.16h1.177l1.005-2.201h4.03zM49.181 108.995l6.597 6.915v-6.493h1.099v9.149l-6.605-6.911v6.549h-1.091v-9.209zM68.597 111.097c-.625-.562-1.491-.863-2.32-.863-1.965 0-3.469 1.643-3.469 3.59 0 1.923 1.489 3.565 3.449 3.565.864 0 1.688-.324 2.339-.909v1.296a4.734 4.734 0 0 1-2.306.615c-2.511 0-4.583-1.992-4.583-4.534 0-2.6 2.086-4.63 4.679-4.63.771 0 1.55.19 2.209.597v1.273h.002zM73.64 109.417h1.092v8.787H73.64v-8.787zM84.969 115.001H81.84l1.572-3.558 1.557 3.558zm.451 1.002l1.005 2.201h1.177l-4.19-9.16-4.199 9.16h1.174l1.002-2.201h4.031zM93.198 117.207h2.671v.997h-3.763v-8.787h1.092v7.79zM111.395 111.085c-.318-.551-.74-.83-1.41-.83-.701 0-1.473.477-1.473 1.249 0 .685.686 1.049 1.23 1.258l.625.247c1.252.487 2.184 1.177 2.184 2.644 0 1.599-1.238 2.738-2.809 2.738-1.424 0-2.531-1.047-2.713-2.458l1.105-.231c-.014.965.756 1.665 1.695 1.665.947 0 1.621-.79 1.621-1.714 0-.942-.756-1.352-1.512-1.669l-.604-.253c-1.006-.432-1.914-1.002-1.914-2.227 0-1.424 1.258-2.277 2.59-2.277.975 0 1.781.481 2.256 1.33l-.871.528zM117.512 109.417h4.724v1.002h-3.625v2.463h3.526v1.001h-3.526v3.324h3.625v.997h-4.724v-8.787zM128.457 110.396h.281c1.094 0 2.396.198 2.396 1.576 0 1.397-1.219 1.605-2.336 1.605h-.342v-3.181h.001zm1.594 3.988c1.27-.154 2.109-1.2 2.109-2.461 0-.838-.422-1.668-1.158-2.1-.697-.395-1.537-.406-2.314-.406h-1.328v8.787h1.098v-3.713h.451l2.588 3.713h1.326l-2.772-3.82zM140.352 115.921l2.611-6.504h1.203l-3.814 9.258-3.821-9.258h1.201l2.62 6.504zM148.641 109.417h1.097v8.787h-1.097v-8.787zM161.555 111.097c-.633-.562-1.5-.863-2.332-.863-1.963 0-3.467 1.643-3.467 3.59 0 1.923 1.488 3.565 3.447 3.565.865 0 1.697-.324 2.352-.909v1.296a4.774 4.774 0 0 1-2.312.615c-2.504 0-4.586-1.992-4.586-4.534 0-2.6 2.096-4.63 4.678-4.63.771 0 1.551.19 2.221.597v1.273h-.001zM166.617 109.417h4.723v1.002h-3.623v2.463h3.519v1.001h-3.519v3.324h3.623v.997h-4.723v-8.787zM180.359 111.085c-.32-.551-.74-.83-1.404-.83-.697 0-1.469.477-1.469 1.249 0 .685.68 1.049 1.223 1.258l.635.247c1.242.487 2.174 1.177 2.174 2.644 0 1.599-1.236 2.738-2.809 2.738-1.418 0-2.533-1.047-2.711-2.458l1.102-.231c-.014.965.762 1.665 1.703 1.665.945 0 1.623-.79 1.623-1.714 0-.942-.764-1.352-1.518-1.669l-.605-.253c-1.006-.432-1.914-1.002-1.914-2.227 0-1.424 1.26-2.277 2.59-2.277.975 0 1.783.481 2.264 1.33l-.884.528zM182.367 77.149c0 .212-.145.324-.439.324h-.1v-.633h.107c.292.001.432.101.432.309zm.862 1.673l-.801-1.006c.342-.088.539-.338.539-.682 0-.476-.334-.745-.928-.745h-.775v2.433h.574v-.942l.682.942h.709zm1.023-1.221c0-1.162-.945-2.12-2.092-2.12a2.111 2.111 0 0 0-2.125 2.12c0 1.181.949 2.123 2.125 2.123 1.147-.001 2.092-.958 2.092-2.123zm-.428.006c0 .954-.75 1.736-1.674 1.736-.93 0-1.695-.778-1.695-1.736 0-.969.758-1.739 1.695-1.739.924 0 1.674.782 1.674 1.739z' />
			</g>
		</SvgIcon>
	);
};

export default Discover;
